import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { SwapButton } from '@root/entities/trade-type/ui'
import { QuickBuyButton } from '@root/features/trade/swap/ui/desktop'

import { FavoritePairListItemHeader } from './favorite-pair-list-item-header'
import { FavoritePairsListInfo } from './favorite-pairs-list-item-info'

import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type FavoritePairsListItemProps = {
  pair: PairModel
  parity?: 'even' | 'odd'
} & ClassNameProps

export const FavoritePairsListItem: React.FC<FavoritePairsListItemProps> = ({
  className,
  pair,
  parity = 'even',
}) => {
  const { t } = useTranslation()

  const handleSell = () => {
    // TODO: Sell position button, see https://github.com/Deluge-Cash/deluge-bot/issues/1721
  }

  return (
    <FavoritePairsListItemRoot className={className} data-parity={parity}>
      <FavoritePairListItemHeader pair={pair} />
      <Footer>
        <FavoritePairsListInfo pair={pair} />
        <Action>
          {/* TODO: Separate section for favorites */}
          <ButtonBuy pair={pair} withIcon withLabel section="exploreFeeds" />
          <ActionSeparator />
          <ButtonSell
            swapDirection="sell"
            onClick={handleSell}
            disabled
            busy={false}
          >
            {t('trading.sell')}
          </ButtonSell>
        </Action>
      </Footer>
    </FavoritePairsListItemRoot>
  )
}

export const FavoritePairsListItemRoot = styled.div`
  display: grid;
  min-height: 114px;

  &[data-parity='even'] {
    background: var(--background-1);
  }
  &[data-parity='odd'] {
    background: var(--appearanceA-3);
  }

  border-bottom: 1px solid var(--backgroundA-3);
`

const Action = styled.div`
  display: grid;
  grid-template-columns: auto 1px auto;
  gap: 6px;

  justify-content: center;
  align-items: center;
`

const ActionSeparator = styled.div`
  height: 16px;
  width: 1px;
  background: var(--background-3);
`

const ButtonSell = styled(SwapButton)`
  --button-radius-rounded: 6px;

  font-size: var(--typography-body-5-semi-bold-font-size);
  font-weight: var(--typography-body-5-semi-bold-font-weight);
  line-height: var(--typography-body-5-semi-bold-line-height);
  width: 47px;
  height: 24px;
`

const ButtonBuy = styled(QuickBuyButton)`
  border-radius: 6px;

  padding-block: 0;
  height: 24px;
  gap: 2px;
  min-width: 50px;
`

const Footer = styled.div`
  border-top: 1px solid var(--backgroundA-3);
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 6px;
  padding: 8px 12px;

  padding-block: 8px;
  padding-inline: 12px;
`
